/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

import { Box, Typography } from "@mui/joy";
import { useTranslation } from "react-i18next";

interface RecommendedBadgeProps {
  show?: boolean;
  /** Overrides the default "Recommended" text (e.g. "Most Popular"). */
  label?: string;
  /** Badge background; defaults to the login button's green. */
  bgcolor?: string;
  /** "md" renders larger text and padding than the default "sm". */
  size?: "sm" | "md";
}

export function RecommendedBadge({
  show = true,
  label,
  bgcolor = "success.600",
  size = "sm",
}: RecommendedBadgeProps): JSX.Element {
  const { t } = useTranslation();

  if (!show) return <></>;

  return (
    <Box
      sx={{
        position: "absolute",
        top: size === "md" ? "-8px" : "-6px",
        right: "8px",
        backgroundColor: bgcolor,
        color: "white",
        borderRadius: "8px",
        padding: size === "md" ? "2px 8px" : "1px 6px",
        fontSize: "0.625rem",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "0.3px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        zIndex: 1,
      }}
    >
      <Typography
        level="body-xs"
        sx={{
          color: "white",
          fontWeight: "bold",
          fontSize: size === "md" ? "0.65rem" : "0.5rem",
        }}
      >
        {label ?? t("recommendedBadge.recommended")}
      </Typography>
    </Box>
  );
}
